module.exports = __webpack_public_path__ + "img/stickers-attestation-domicile.cf6c77ff.jpg";